import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'my',
    fullName: 'Burmese',
    nativeName: 'မြန်မာ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "အံ့ဩစရာ တစ်ခုခု လာနေပြီ။",
    landing_subtitle: "ArgVoid သည် အက်ပ်နှင့် ဂိမ်းတည်ဆောက်ရေးစတူဒီယိုတစ်ခုဖြစ်သည်။ စောင့်မျှော်ကြည့်ရှုပါ၊ အသစ်အသစ်များမကြာမီလာမည်။",
    select_language: "ဘာသာစကားကို ရွေးပါ။",
    search_placeholder: "ဘာသာစကားများကို ရှာဖွေပါ...",
    terms_title: "ဝန်ဆောင်မှုစည်းမျဉ်းများ",
    policy_title: "ကိုယ်ရေးအချက်အလက်မူဝါဒ",
    cookies_title: "ကွတ်ကီးမူဝါဒ",
    terms_content: `
        <strong>1။ စည်းမျဥ်းများ</strong><br> ကို လက်ခံခြင်း။
        ArgVoid ကိုဝင်ရောက်ခြင်းဖြင့် ဤဝန်ဆောင်မှုစည်းမျဉ်းများကို လက်ခံပါသည်။ ဤစည်းကမ်းချက်များကို သဘောမတူပါက၊ ဝန်ဆောင်မှုကို အသုံးမပြုသင့်ပါ။<br><br>

        <strong>2။ ပလပ်ဖောင်းအသုံးပြုမှု</strong><br>
        ArgVoid နှင့် ၎င်း၏ အပလီကေးရှင်းများကို သတင်းအချက်အလက်နှင့် ဖန်တီးမှုဆိုင်ရာ ရည်ရွယ်ချက်များအတွက် "အတိုင်း" ပေးထားသည်။ ဝန်ဆောင်မှုကို တရားဝင်ရည်ရွယ်ချက်များအတွက်သာ အသုံးပြုရပါမည်။<br><br>

        <strong>3။ တားမြစ်ထားသော Conduct</strong><br>
        ဝဘ်ဆိုက် အားနည်းချက်များကို အသုံးချခြင်း၊ စပမ်းပို့ခြင်း သို့မဟုတ် အခြေခံအဆောက်အဦများသို့ ခွင့်ပြုချက်မရှိဘဲ ဝင်ရောက်ရန် ကြိုးပမ်းခြင်းကို တင်းတင်းကျပ်ကျပ် တားမြစ်ထားသည်။<br><br>

        <strong>4။ Disclaimer</strong><br>
        ပလပ်ဖောင်းနှင့် ဝန်ဆောင်မှုများကို အသိပေးခြင်းမရှိဘဲ အချိန်မရွေး ပြင်ဆင်နိုင်ပါသည်။ ဝန်ဆောင်မှု၏ အလုပ်ချိန် သို့မဟုတ် ရရှိနိုင်မှုနှင့်ပတ်သက်၍ အာမခံမပေးပါ။
    `,
    policy_content: `
        <strong>1။ အချက်အလက်စုဆောင်းခြင်း</strong><br>
        ပလက်ဖောင်းသည် ယခုအချိန်တွင် အသုံးပြုသူအထောက်အထားစိစစ်ခြင်း သို့မဟုတ် အကောင့်ဖန်တီးခြင်း မလိုအပ်ပါ။ ဧည့်သည်များထံမှ ကိုယ်ရေးကိုယ်တာ ခွဲခြားသတ်မှတ်ခြင်းဆိုင်ရာ အချက်အလက် (အမည်များ သို့မဟုတ် အီးမေးလ်လိပ်စာများကဲ့သို့) အားတက်ကြွစွာ စုဆောင်းထားခြင်းမရှိပါ။<br><br>

        <strong>2။ Data</strong><br> ကို အသုံးပြုခြင်း။
        ဆိုက်အသွားအလာကို နားလည်ပြီး အပလီကေးရှင်းများကို တိုးတက်ကောင်းမွန်လာစေရန် အခြေခံအမည်ဝှက်ထားသော ခွဲခြမ်းစိတ်ဖြာမှုများကို စုဆောင်းနိုင်ပါသည်။ ဤဒေတာသည် သုံးစွဲသူတစ်ဦးချင်းစီ၏ အထောက်အထားများနှင့် ချိတ်ဆက်ထားခြင်းမရှိပါ။<br><br>

        <strong>3။ Third-Party Services</strong><br>
        Third-party ပံ့ပိုးပေးသူများကို hosting နှင့် analytics ဝန်ဆောင်မှုများအတွက် အသုံးပြုနိုင်ပါသည်။ ဤသက်ဆိုင်ရာဝန်ဆောင်မှုပေးသူများ၏ ကိုယ်ရေးကိုယ်တာအလေ့အကျင့်များသည် ၎င်းတို့၏အခြေခံအဆောက်အဦတွင် လုပ်ဆောင်ခဲ့သော အမည်မသိဒေတာများကို အုပ်ချုပ်ပါသည်။<br><br>

        <strong>4။ ဒေတာလုံခြုံရေး</strong><br>
        ပလက်ဖောင်းကို ကာကွယ်ရန် ကျိုးကြောင်းဆီလျော်သော လုံခြုံရေးအစီအမံများကို အကောင်အထည်ဖော်သည်။ သို့သော်၊ အင်တာနက်မှတဆင့် ထုတ်လွှင့်သည့်နည်းလမ်းသည် လုံးဝလုံခြုံပါသည်။<br><br>
    `,
    cookies_content: `
        <strong>1။ Cookies နှင့် Local Storage ဆိုသည်မှာ အဘယ်နည်း။</strong><br>
        ကွတ်ကီးများနှင့် ဘရောင်ဇာတွင်း သိုလှောင်မှုတို့သည် လည်ပတ်မှုများတစ်လျှောက် စီစဉ်သတ်မှတ်မှုဆိုင်ရာ စိတ်ကြိုက်ရွေးချယ်မှုများကို မှတ်မိစေရန် စက်တွင် သိမ်းဆည်းထားသည့် အသေးစားဒေတာဖိုင်များဖြစ်သည်။<br><br>

        <strong>2။ အသုံးပြုမှု ရည်ရွယ်ချက်</strong><br>
        Browser LocalStorage ကို:<br> ကဲ့သို့သော configuration ဆက်တင်များကို သိမ်းဆည်းရန် တင်းကြပ်စွာ အသုံးပြုပါသည်။
        - ဘာသာစကား ဦးစားပေးများ<br>
        - အသုံးပြုသူ အင်တာဖေ့စ်ဖွဲ့စည်းပုံ (ဥပမာ၊ အပြင်အဆင် သို့မဟုတ် အပြင်အဆင် ဆက်တင်များ) <br>
        - ယာယီအပလီကေးရှင်း cache<br><br>

        <strong>3။ Tracking</strong><br> မရှိပါ။
        ကွတ်ကီးများနှင့် ဒေသတွင်းသိုလှောင်မှုကို ကြော်ငြာခြင်း သို့မဟုတ် ပြင်ပကုမ္ပဏီ ခြေရာခံခြင်းရည်ရွယ်ချက်များအတွက် အသုံးမပြုပါ။ သိမ်းဆည်းထားသောဒေတာအားလုံးသည် ပလပ်ဖောင်း၏ အဓိကလုပ်ဆောင်နိုင်စွမ်းအတွက် အတိအကျဖြစ်သည်။<br><br>

        <strong>4။ Control</strong><br>
        ဘရောက်ဆာဒေတာကို ဘရောက်ဆာဆက်တင်များမှတဆင့် အချိန်မရွေးရှင်းလင်းနိုင်ပြီး၊ မည်သည့်ဒေသခံဖွဲ့စည်းပုံများကိုမဆို ပြန်လည်သတ်မှတ်ပါမည်။
    `,
    cookie_consent_text: "သင့်စက်ရှင်ကို အသက်ဝင်အောင်ထားရန်၊ သင့်ဘာသာစကား နှစ်သက်ရာကို သိမ်းဆည်းခြင်းနှင့် အခြားသော စိတ်ကြိုက်ဖွဲ့စည်းပုံများကဲ့သို့သော ဝဘ်ဆိုက်၏ လုပ်ဆောင်ချက်များကို မှန်ကန်ကြောင်းသေချာစေရန် ကျွန်ုပ်တို့သည် အခြေခံ cookies များကို အသုံးပြုပါသည်။",
    read_policy: "Cookie Policy ကိုဖတ်ပါ။",
    support_title: "ပံ့ပိုးကူညီမှုထံ ဆက်သွယ်ပါ။",
    support_subject_label: "ဘာသာရပ်",
    support_message_label: "မက်ဆေ့ချ်",
    support_submit_button: "Message ပို့ပါ။",
    support_hint: "မှတ်ချက်- ၎င်းသည် မက်ဆေ့ချ်ပေးပို့ရန် သင်၏ မူရင်းအီးမေးလ်အက်ပ်ကို ဖွင့်ပေးမည်ဖြစ်သည်။",
    support_success_msg: "သင့်အီးမေးလ်အက်ပ်ကို ဖွင့်နေသည်...",
    support_error_msg: "မက်ဆေ့ချ်ပို့၍မရပါ။ နောက်မှ ထပ်စမ်းကြည့်ပါ။",
    explorer_title: "Explorer",
    history_title: "သမိုင်း",
    animation_title: "ကာတွန်း",
    config_title: "ဖွဲ့စည်းမှု",
    tool_mouse: "(Ctrl+M) ကို ရွေးပါ",
    tool_brush: "စုတ်တံ (Ctrl+B)",
    tool_brush_mode: "မုဒ်ပြောင်းရန် (အစိုင်အခဲ/ရှင်းလင်း)",
    tool_eraser: "ခဲဖျက် (Ctrl+E)",
    tool_brush_size: "Brush အရွယ်အစားကို ချိန်ညှိပါ။",
    tool_bucket: "ဖြည့်ပါ (Ctrl+F)",
    tool_eyedropper: "မျက်စဉ်းဆေး",
    tool_grid: "ဇယားကွက် (Ctrl+Shift+B)",
    tool_rotate: "လှည့်ပါ (Ctrl+Shift+R)",
    tool_flip_h: "H ကိုလှန်ပါ (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "အကျယ်",
    label_height: "အရပ်အမြင့်",
    label_frames: "Frames အရေအတွက်",
    label_animation: "အန်နီမေးရှင်းပုံစံ",
    label_background_color: "နောက်ခံအရောင်",
    label_interval: "ကြားကာလ",
    tool_anim_config: "အန်နီမေးရှင်းဖွဲ့စည်းမှု",
    label_new_width: "အကျယ်အသစ်",
    label_new_height: "အမြင့်",
    label_apply: "လျှောက်ထားပါ။",
    label_colors: "အရောင်များ",
    label_size: "အရွယ်အစား",
    label_tolerance: "စာနာထောက်ထားမှု",
    val_horizontal: "အလျားလိုက်",
    val_vertical: "ဒေါင်လိုက်",
    val_sequence: "တစ်ဆက်တည်း",
    val_bounce: "ဘောင်း",
    val_random: "ကြုံသလို",
    val_solid: "အစိုင်အခဲ",
    val_clear: "ရှင်းပါတယ်။",
    action_add_sheet: "စာရွက်အသစ်",
    action_import: "သွင်းကုန်",
    action_export: "တင်ပို့ခြင်း။",
    action_sort_projects: "မျိုးတူစု",
    sort_date_old: "အသက်အကြီးဆုံး ပထမ",
    sort_date_new: "အသစ်ဆုံး ပထမ",
    sort_name_az: "အမည် (A-Z)",
    sort_name_za: "အမည် (Z-A)",
    action_new_sprite: "Sprite အသစ်",
    action_new_project: "ပရောဂျက်အသစ်",
    modal_save_all_title: "ပြောင်းလဲမှုအားလုံးကို သိမ်းဆည်းပါ။",
    modal_save_all_desc: "သိမ်းဆည်းရန် ပိုင်ဆိုင်မှုများကို ရွေးပါ",
    modal_save_selected: "သိမ်းဆည်းရန် ရွေးချယ်ထားသည်။",
    action_saved: "သိမ်းဆည်းထားသည်။",
    modal_create_sprite_title: "Sprite အသစ်ကိုဖန်တီးပါ။",
    modal_create_project_title: "ပရောဂျက်အသစ်ဖန်တီးပါ။",
    modal_add_sheet_title: "စာရွက်အသစ်ထည့်ပါ။",
    modal_rename_sheet_title: "စာရွက်အမည်ပြောင်း",
    modal_rename_sprite_title: "Sprite ကို အမည်ပြောင်းပါ။",
    modal_delete_sprite_title: "Sprite ကိုဖျက်ပါ။",
    modal_delete_project_title: "ပရောဂျက်ကိုဖျက်ပါ။",
    modal_delete_sheet_title: "စာရွက်ကိုဖျက်ပါ။",
    placeholder_sprite_name: "နာမည်",
    placeholder_project_name: "နာမည်",
    placeholder_sheet_name: "နာမည်",
    placeholder_new_name: "နာမည်အသစ်",
    action_create: "ဖန်တီးပါ။",
    action_add: "ထည့်ပါ။",
    action_rename: "အမည်ပြောင်းပါ။",
    action_duplicate: "ပွား",
    action_delete: "ဖျက်ပါ။",
    action_cancel: "မလုပ်တော့",
    confirm_delete_sprite: "ဤစပရက်စ်ကို ဖျက်လိုသည်မှာ သေချာပါသလား။",
    confirm_delete_project: "ဤပရောဂျက်ကို ဖျက်လိုသည်မှာ သေချာပါသလား။ sprites အားလုံးကိုဖယ်ရှားလိမ့်မည်။",
    confirm_delete_sheet: "ဤစာရွက်ကို ဖျက်လိုသည်မှာ သေချာပါသလား။",
    err_select_sprite: "ကျေးဇူးပြု၍ ပထမဦးစွာ sprite ကိုရွေးချယ်ပါ။",
    err_select_project: "ပရောဂျက်တစ်ခုကို ဦးစွာရွေးချယ်ပါ။",
    err_name_empty: "အမည် ဗလာမဖြစ်ရပါ။",
    err_sprite_exists: "အဲဒီနာမည်နဲ့ sprite က ရှိပြီးသားပါ။",
    err_project_exists: "ထိုအမည်ဖြင့် ပရောဂျက်တစ်ခု ရှိနှင့်ပြီးဖြစ်သည်။",
    err_no_content: "သိမ်းဆည်းရန် အကြောင်းအရာမရှိပါ။",
    err_no_changes: "သိမ်းဆည်းရန် အပြောင်းအလဲမရှိပါ။",
    err_delete_last_sheet: "နောက်ဆုံးစာရွက်ကို ဖျက်၍မရပါ။",
    err_extract_frames: "မည်သည့်ဘောင်မှ မထုတ်ယူနိုင်ပါ။",
    err_indexeddb: "စက်အတွင်း သိမ်းဆည်းရန် မအောင်မြင်ပါ။ သင့်ဘရောက်ဆာသည် IndexedDB ကို မပံ့ပိုးနိုင်ပါ။",
    msg_upload_success: "အပ်လုဒ်တင်ခြင်း အောင်မြင်သည်- {0}",
    msg_upload_failed: "အပ်လုဒ် မအောင်မြင်ပါ- {0}",
    msg_save_success: "အောင်မြင်စွာ သိမ်းဆည်းပါ။",
    msg_saving: "သိမ်းဆည်းနေသည်...",
    msg_multi_save_result: "ပိုင်ဆိုင်မှု {0} ခုကို သိမ်းဆည်းထားသည်။ {1} ရှုံးနိမ့်မှုများ။",
    menu_title: "မီနူး",
    menu_save: "သိမ်းဆည်းပါ။",
    menu_save_all: "အားလုံးကို သိမ်းဆည်းပါ။",
    menu_support: "ပံ့ပိုးကူညီမှုထံ ဆက်သွယ်ပါ။",
    label_local_storage: "Local Storage",
    label_sign_in: "ဆိုင်းအင်လုပ်ခြင်း",
    modal_export_title: "Sprite ကို တင်ပို့ပါ။",
    label_filename: "ဖိုင်နာမည်",
    label_format: "ပုံစံ",
    action_export_confirm: "တင်ပို့ခြင်း။",
};

export default translations;
